module.exports = __webpack_public_path__ + "static/media/LogoAppMosph2.35a94f8d.png";